export default __webpack_public_path__ + "static/media/rightBg-dark.847b214a.png";